import { FC } from 'react';

// Props interface defining the properties the FormBaseError component expects
interface Props {
  error?: string | null; // Optional error message
}

/**
 * FormBaseError component: A component to display error messages
 * related to form input elements in a consistent styling.
 *
 * Height must not be collapsed (e.g. h-0): long validation messages need to
 * reserve layout space so they don't overlap fields or buttons below.
 */
const FormBaseError: FC<Props> = ({ error }: Partial<Props>) => (
  <span className="mt-0.5 block text-xs leading-snug text-red-500">{error}</span>
);

export { FormBaseError };
